import React, { useEffect, useState } from 'react'
import SideNavClass from './SideNavClass'

import { isMobile } from 'react-device-detect';
import {
    MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBChip, MDBCol, MDBIcon, MDBInput, MDBRow, MDBSelect, MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBTextArea,
    MDBChipsInput,
    MDBCheckbox,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
    MDBAlert,
} from 'mdb-react-ui-kit';
import CreateClass from '../../components/class/createClass.js';
import { deleteClass, getCategory, getClass, getClassList, getGymPlansList } from '../../services/classApiServices.js';
import ClassCategory from './classCategory';
import { getAllSubDomain, getGymAddonsList, logEvent } from '../../services/apiServices';
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics';
import { useAccess } from '../../context/AccessContext';
import copy from 'clipboard-copy';
import { idToSlug } from '../../utils/slug';



const Classes = () => {
    const { trackButtonClick } = useAnalytics();
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const [copyLink, setCopyLink] = useState(false);
    const isAdmin = loggedUserInfo?.role !== "staff";
    const [basicActive, setBasicActive] = useState("tab1");
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [centredModal, setCentredModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [classData, setClassData] = useState(null)
    const toggleOpen = () => setCentredModal(!centredModal);
    const [classes, setClasses] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [classid, setClassid] = useState(-1)
    const [plans, setPlans] = useState([])
    const [applyFilterClicked, setApplyFilterClicked] = useState(false)
    const [resetFilterClicked, setResetFilterClicked] = useState(false)
    const [classCategory, setClassCategory] = useState([])
    const [mfilter, setMfilter] = useState({
        inputName: "",
        category: "",
        level: "",
    })
    const [className, setClassName] = useState("")
    const [Currentdomain, setCurrentdomain] = useState({})
    const [Error2, setError2] = useState("")
    const [addons, setAddons] = useState([]);
    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("classes")

    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };


    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }

    useEffect(() => {

        async function fetchPlans() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGymPlansList(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    // setApiError(true)
                } else {
                    const tempData = await response.json();


                    setPlans(tempData);

                }

            }
        }


        fetchPlans();

    }, []);
    useEffect(() => {
        if (localStorage.getItem("loggedUserInfo")) {
            fetchsubDomains()
        }
    }, [])
    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }
    async function fetchsubDomains() {
        const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;

        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();

        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
    }
    const handlecopyDomainuserUrl = (id) => {
        console.log(id, 'slug');
        const slug = idToSlug(id);
        let currentUrl = window.location.origin;
        // console.log("currentUrl", currentUrl);
        // const subdomain = Currentdomain?.subdomain;

        // if (currentUrl.includes("portal.") && subdomain) {
        //     currentUrl = currentUrl.replace("portal", subdomain);
        // }
        let link = `${window.location.protocol}//${window.location.hostname}/api/classes/${slug}`;
        if (link.includes("localhost")) {
            link = `${currentUrl}/class?cid=${slug}`
        }
        console.log(link, 'link');
        copy(link);
        setCopyLink(true);
    };

    useEffect(() => {
        async function fetchAddons() {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
                if (!loggedUser?.gymid) return;

                const response = await getGymAddonsList(loggedUser.gymid);
                if (!response) return;


                if (response === "false" || response?.status === false) {
                    return;
                }

                const resp = typeof response.json === "function"
                    ? await response.json()
                    : response;

                if (Array.isArray(resp) && resp.length > 0) {
                    const filteredResp = resp
                        .filter(addon => addon?.enable === true)
                        .map(addon => ({ ...addon, type: "addons" }));
                    setAddons(filteredResp);

                }
            } catch (error) {
                console.error("Error fetching addons:", error);

            }
        }

        fetchAddons();

    }, []);



    useEffect(() => {

        const fetchData = async () => {
            let filter = {}

            filter.inputName = mfilter.inputName
            filter.category = mfilter.category
            filter.level = mfilter.level
            const response = await getClassList(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, filter);
            if (!response || response === "false") {
                return;
            }
            const classinfo = await response.json();

            console.log(classinfo, 'classsssssssss');
            setClasses(classinfo)
            setRefresh(false)
            setApplyFilterClicked(false)
            setResetFilterClicked(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }


    }, [refresh, applyFilterClicked, resetFilterClicked])

    useEffect(() => {

        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getCategory(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    // setApiError(true)
                } else {
                    const tempData = await response.json();
                    console.log(tempData);
                    setClassCategory(tempData);

                }
                setRefresh(false)
            }
        }


        fetchData();

    }, [refresh]);

    const handleEdit = (data) => {
        setClassData(data)
        toggleOpen()
    }

    const confirmDelete = async () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        try {
            const res = await deleteClass(gymid, classid);

            const data = await res.json();
            const flag = `Class deleted successfully (${className})`;
            setError2(flag);

            if (res?.ok || data?.success) {
                await logEvent(
                    {
                        Eventtype: username1,
                        username1,
                        fullName,
                        ip,
                        flag,
                        browserinfo,
                        gymid,

                        isclass: true
                    },
                    gymid
                );
                await trackButtonClick("Classes", "Delete_Class", "staff", {});
                setRefresh(true);
                setDeleteModal(false);
            } else {
                console.error("Failed to delete class:", data?.message || "Unknown error");
            }
        } catch (error) {
            console.error("Error deleting class:", error);
        }
    };



    const handleDelete = (data) => {

        setClassid(data._id)
        setClassName(data?.name)
        setDeleteModal(true)
    }

    const handleSave = async (isUpdate = false, prevClassName = "") => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "User";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const flag = isUpdate
            ? `class updated sucessfully (${prevClassName} )`
            : `class created sucessfully (${prevClassName})`;
        setError2(flag);

        await logEvent(
            {
                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true,
            },
            gymid
        );
        await trackButtonClick("Classes", isUpdate ? "Update_Class" : "Created_Class", "staff", {});
        setRefresh(true);
        setCentredModal(false);
        setClassData(null);
    };



    console.log(plans, 'plansssssssssssssssssss');








    const handleApplyAndToggle = async () => {

        // setLoading(true);
        setApplyFilterClicked(true)
    }

    const handleResetAndToggle = () => {

        setMfilter({
            inputName: "",
            category: "",
            level: "",
        });
        setResetFilterClicked(true)

        // fetchData()
    }

    const handlecancel = () => {

        setCentredModal(false);
        setClassData(null)
        toggleOpen()
    }

    const showAlert = (flag) => {
        console.log("Error2flag", flag);
        setError2(flag)
    }
    return (
        <>
            <SideNavClass activeTab={"Classes"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >
                {isMobile && <>
                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>
                </>}


                <MDBCard className='shadow-3 overflow-hidden'>
                    <MDBCardBody className='custom-card-height'>
                        {/* <div className="d-flex align-items-center justify-content-between">
                            <h5 className='m-0'>
                                Classes Management
                            </h5>
                          
                        </div> */}
                        <div>
                            <div className=" ">

                                <MDBTabs>
                                    <MDBTabsItem>
                                        <MDBTabsLink
                                            onClick={() => handleBasicClick("tab1")}
                                            active={basicActive === "tab1"}
                                        >
                                            Classes
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                    <MDBTabsItem>
                                        <MDBTabsLink
                                            onClick={() => handleBasicClick("tab2")}
                                            active={basicActive === "tab2"}
                                        >
                                            Class Categories
                                        </MDBTabsLink>
                                    </MDBTabsItem>

                                </MDBTabs>

                            </div>

                            <MDBTabsContent>
                                <MDBTabsPane open={basicActive === "tab1"} show={basicActive === "tab1"}>
                                    <div>

                                        <div className="my-4 d-flex flex-mob-col justify-content-between align-items-end">
                                            <div className=" d-flex flex-mob-col">
                                                <div>
                                                    <label className='fw-bold mb-1'>Search</label>
                                                    <MDBInput placeholder='Search by Class Name' size="sm" value={mfilter.inputName}
                                                        onChange={(e) => setMfilter({
                                                            ...mfilter,
                                                            inputName: e.target.value
                                                        })} /></div>
                                                <div className="ms-3">
                                                    <div className="form-group">
                                                        <label className='fw-bold mb-1'>Level</label>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            name="level"
                                                            value={mfilter.level}
                                                            onChange={(e) => setMfilter({
                                                                ...mfilter,
                                                                level: e.target.value
                                                            })}
                                                        >
                                                            <option value="">All</option>
                                                            <option value="Beginner">Beginner</option>
                                                            <option value="Intermediate">Intermediate</option>
                                                            <option value="Advanced">Advanced</option>
                                                            <option value="All Levels">All Levels</option>
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className="ms-3">
                                                    {/* <MDBSelect
                                    data={[
                                        { text: 'One', value: 1 },
                                        { text: 'Two', value: 2 },
                                        { text: 'Three', value: 3 },
                                        { text: 'Four', value: 4 },
                                        { text: 'Five', value: 5 },
                                        { text: 'Six', value: 6 },
                                        { text: 'Seven', value: 7 },
                                        { text: 'Eight', value: 8 },
                                    ]}
                                /> */}
                                                    <div className="form-group">
                                                        <label className='fw-bold mb-1'>Category</label>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            name="category"
                                                            value={mfilter.category}
                                                            onChange={(e) =>
                                                                setMfilter({
                                                                    ...mfilter,
                                                                    category: e.target.value,
                                                                })
                                                            }
                                                        >
                                                            <option value="">All</option>
                                                            {classCategory.map((cat) => (
                                                                <option key={cat._id} value={cat.name}>
                                                                    {cat.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="gym-section order-5 ms-3 my-0 align-self-end" >
                                                    <div className="">
                                                        <button type="submit" className="me-2 btn btn-primary custom-btn"
                                                            onClick={(e) => handleApplyAndToggle()}
                                                        >
                                                            Apply
                                                        </button>
                                                        <button type="submit" className="   btn btn-secondary custom-btn"
                                                            onClick={(e) => handleResetAndToggle()}
                                                        >
                                                            Clear
                                                        </button>
                                                        {/* {RoleValue === "admin" &&
                                        <button type="submit" className="ms-2 btnheight btn btn-primary"
                                            onClick={(e) => downloaddata(basicActive === "tab1" ? basicData : basicDataP)}
                                        >
                                            <MDBIcon fas icon="download" className="d-inline me-1" />Export
                                        </button>} */}
                                                    </div>


                                                </div>
                                            </div>
                                            <div className='classmob-btn'>
                                                {roleAccess?.editclass !== 2 &&
                                                    <>
                                                        <MDBBtn color='success' className='text-capitalize' onClick={toggleOpen}>
                                                            <MDBIcon fas icon="plus" className="me-2" />
                                                            Add New Class
                                                        </MDBBtn></>}
                                            </div>

                                        </div>
                                        <div className="">
                                            <MDBRow className='cardInnerScroll'>
                                                {classes && classes.length > 0 ? classes.map((classItem) => (
                                                    <MDBCol key={classItem.id} sm={12} lg={6} md={6} className='mt-2'>
                                                        <MDBCard className='card-gym  m-0'>
                                                            <MDBCardBody>
                                                                <div className="d-flex align-items-center justify-content-between">
                                                                    <MDBCardTitle>{classItem.name}</MDBCardTitle>
                                                                    <span class="badge badge-primary ms-2">{classItem.level}</span>


                                                                </div>
                                                                {/* <MDBCardText>{classItem.description}</MDBCardText> */}
                                                                <MDBRow>
                                                                    <MDBCol sm={12} md={6} lg={6}>
                                                                        <p>
                                                                            <MDBIcon far icon="clock" className="me-2" />
                                                                            {classItem.duration} minutes
                                                                        </p>
                                                                    </MDBCol>
                                                                    <MDBCol sm={12} md={6} lg={6}>
                                                                        <p>
                                                                            <MDBIcon fas icon="dumbbell" className="me-2" />
                                                                            {classItem.category}
                                                                        </p>
                                                                    </MDBCol>
                                                                    <MDBCol sm={12} md={6} lg={6}>
                                                                        <p className="m-0">
                                                                            <MDBIcon fas icon="user-friends" className="me-2" />
                                                                            Max {classItem.slots} people
                                                                        </p>
                                                                    </MDBCol>
                                                                    <MDBCol sm={12} md={6} lg={6}>
                                                                        <p className="m-0">
                                                                            <MDBIcon far icon="money-bill-alt" className="me-2" />
                                                                            &#8377;{classItem.price} /-
                                                                        </p>
                                                                    </MDBCol>


                                                                </MDBRow>



                                                                <p className="mt-3 mb-0">
                                                                    <strong>Membership Discounts:</strong>
                                                                </p>
                                                                <div className="d-flex wrap">
                                                                    {classItem.membershipdiscount && classItem.membershipdiscount.length > 0
                                                                        ? classItem.membershipdiscount.map((item) => {
                                                                            let plan = plans.find((p) => p._id === item.membershipname);


                                                                            if (!plan) {
                                                                                plans.forEach((p) => {
                                                                                    if (p.subplans && p.subplans.length > 0) {
                                                                                        const sub = p.subplans.find((sp) => sp._id === item.membershipname);
                                                                                        if (sub) {
                                                                                            plan = {
                                                                                                ...sub,
                                                                                                name: `${p.name} - ${sub.name}`,
                                                                                                isSubplan: true,
                                                                                                baseplan: p._id,
                                                                                                // baseplanname: p.name,
                                                                                            };
                                                                                        }
                                                                                    }
                                                                                });
                                                                            }

                                                                            return (
                                                                                <MDBChip key={item.membershipname}>
                                                                                    {plan ? plan.name : "Unknown Plan"} - {item.discount}%
                                                                                </MDBChip>
                                                                            );
                                                                        })
                                                                        : <div>--</div>}
                                                                </div>

                                                                <p className="mt-0 mb-0">
                                                                    <strong>Description: </strong>
                                                                </p>
                                                                {/* <p>
                                                                    {classItem?.description ? classItem.description : "--"}
                                                                </p> */}

                                                                <p title={stripHtmlTags(classItem?.description ? classItem.description : "--")} dangerouslySetInnerHTML={{ __html: truncateContent(classItem?.description ? classItem.description : "--", 300) }} />

                                                                {/* <p className="mt-3 mb-0">
                                                    <strong>Tags:</strong>
                                                </p>
                                                <div className="d-flex align-items-center flex-wrap">
                                                    {classItem.tags.map((tag, index) => (
                                                        <MDBChip key={index}>{tag}</MDBChip>
                                                    ))}
                                                </div> */}
                                                                <div >
                                                                    <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                                                                        onClick={() => handlecopyDomainuserUrl(classItem._id)}
                                                                    ><i class="fa-regular fa-copy "></i></span>
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-end">
                                                                    {roleAccess?.editclass !== 2 && <MDBBtn className="me-3" onClick={() => handleEdit(classItem)}>Edit</MDBBtn>}
                                                                    {roleAccess?.editclass !== 2 && <MDBBtn color="danger" className="me-3" onClick={() => isAdmin ? handleDelete(classItem) : undefined}>Delete</MDBBtn>}
                                                                </div>
                                                            </MDBCardBody>
                                                        </MDBCard>
                                                    </MDBCol>
                                                )) : <div>No Class Found</div>}
                                            </MDBRow>
                                        </div>
                                    </div>
                                </MDBTabsPane>
                                <MDBTabsPane open={basicActive === "tab2"} show={basicActive === "tab2"}>

                                    <ClassCategory showAlert={showAlert} />
                                </MDBTabsPane>

                            </MDBTabsContent>


                        </div>
                    </MDBCardBody>
                </MDBCard>



                <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                    <MDBModalDialog centered size='lg'>
                        <MDBModalContent>
                            <CreateClass
                                ispopup="0"
                                onSave={handleSave}
                                onclose={handlecancel}
                                classinfo={classData}
                                plansinfo={plans}
                                addonsinfo={addons}

                            />


                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                {/* Delete Confirmation Modal */}
                <MDBModal odal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>Are you sure you want to delete this class?</p>
                            </MDBModalBody>
                            <MDBModalFooter className='pe-2 pb-2'>
                                <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                    Cancel
                                </MDBBtn>
                                <MDBBtn color="danger" onClick={confirmDelete}>
                                    Delete
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
                <MDBAlert
                    color='success'
                    autohide
                    position='top-right'
                    delay={2000}
                    appendToBody
                    open={copyLink}
                    onClose={() => setCopyLink(false)}
                >
                    <MDBIcon fas icon="check-circle" className="me-2" />
                    Link copied to clipboard!
                </MDBAlert>


                <MDBAlert
                    color='success'
                    autohide
                    position='top-center'
                    delay={5000}
                    appendToBody
                    open={Error2 !== ""}
                    onClose={() => setError2("")}
                >
                    {Error2}
                </MDBAlert>



            </SideNavClass>
        </>
    )
}

export default Classes
